import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { NotificationStore } from "./notification.js";
import { RcbAuthenticationStore } from "./rcb/authentication.js";
import { RcbUserSettingsStore } from "./rcb/user-settings.js";
import { TimerStore } from "./timer.js";
/**
 * A collection of all available stores which gets available
 * through the custom hook useStores in your function components.
 *
 * To have function components working together with our stores we need to wrap them with "observe".
 * With that "observe" given the component recognizes changes from our used stores and triggers re-rendering like react would do with default "setState" values.
 *
 * @see https://mobx.js.org/defining-data-stores.html#combining-multiple-stores
 */ class RootStore {
    static me;
    timerStore;
    notificationStore;
    rcbAuthenticationStore;
    rcbUserSettingsStore;
    contextMemo;
    /**
     * Init stores for global access.
     */ constructor(){
        this.timerStore = new TimerStore(this);
        this.rcbAuthenticationStore = new RcbAuthenticationStore(this);
        this.notificationStore = new NotificationStore(this);
        this.rcbUserSettingsStore = new RcbUserSettingsStore(this);
    }
    /**
     * Singleton pattern to access our FunctionComponent (Typ: Context)
     */ static get StoreProvider() {
        return RootStore.get.context.StoreProvider;
    }
    /**
     *Singleton pattern to access to access our RootStore
     */ static get get() {
        return RootStore.me ? RootStore.me : RootStore.me = new RootStore();
    }
    /**
     * Access context.
     */ get context() {
        return this.contextMemo ? this.contextMemo : this.contextMemo = this.createContextFactory(this);
    }
    /**
     *  Creates the react context provider component.
     */ createContextFactory(store) {
        const StoreContext = /*#__PURE__*/ createContext(store);
        const StoreProvider = ({ children })=>/*#__PURE__*/ _jsx(StoreContext.Provider, {
                value: store,
                children: children
            });
        // Create hook to access all stores via our context.
        const useStores = ()=>useContext(StoreContext);
        return {
            StoreContext,
            StoreProvider,
            useStores
        };
    }
}
// Define useStores hook for export
const useStores = ()=>RootStore.get.context.useStores();
export { RootStore, useStores };
